import React from "react";
import { useHistory } from "react-router-dom";
import { gtag } from "../../../../utils/track";
import Flex from "../../../structure/Flex";
import Button from "../../Button";
import Icon from "../../Icon";
import { trackZostelEvent } from "../../../../utils/tracking";
interface ExperienceCardProps {
  data: any;
}

const ExperienceCard: React.FC<ExperienceCardProps> = ({ data }) => {
  const history = useHistory();
  const handleClick = () => {
    gtag("event", "Experience_Click", { value: data.name });
    trackZostelEvent("Experience_Click", { value: data.name });
    history.push(`/trip/${data.destination.slug}/${data.slug}/`);
  };
  return data != null ? (
    <section className="max-w-sm mx-1 my-1 rounded-lg shadow-lg hover:shadow-xl">
      <Flex items="center" col>
        <div className="relative w-full">
          <img
            src={
              data?.image
                ? data.image
                : "" || (data.images[0]?.image ? data.images[0]?.image : "")
            }
            alt=""
            className="w-full h-40 rounded-t-lg"
          />
          <div className="absolute top-0 right-0 p-1 m-2 text-xs font-medium text-primary bg-white rounded-md">
            <span>{data.category && data.category.toUpperCase()}</span>
          </div>
        </div>
        <div className="flex flex-col w-full h-48 p-2 bg-white rounded-b-lg">
          <div className="flex-1">
            <div className="w-full text-lg font-medium text-primary line-clamp-2">
              <p>{data.title || data.name}</p>
            </div>
            <div className="w-full text-sm text-gray-700">
              <p className="truncate">{data?.destination?.title}</p>
            </div>
          </div>

          {data.cost && (
            <Flex items="center" justify="between">
              <div className="mr-2 text-sm">₹ {data.cost} per person</div>
            </Flex>
          )}
          {data.duration && (
            <Flex items="center" justify="between">
              <div className="flex items-center text-sm">
                <Icon className="text-sm">access_time</Icon>
                <span className="ml-2">{data.duration} Days</span>
              </div>
            </Flex>
          )}
          <Button className="w-full mt-2" onClick={handleClick}>
            Explore Now
          </Button>
        </div>
      </Flex>
    </section>
  ) : (
    <></>
  );
};

export default ExperienceCard;
